<template>
    <div>
        <stat-notification-modal :city-id="cityId" @close="statModalOpen = false" v-if="cityId && statModalOpen && waitingStatistics && cookieStatNotificationDidntSeen"/>
    </div>
</template>
<script>
import StatNotificationModal from '@/views/partners/current-registration/stat-layout/stat-modal/statNotificationModal';
import * as Cookies from 'js-cookie';

export default {
  name: 'statNotification',
  components: { StatNotificationModal },
  props: ['waitingStatistics', 'cityId'],
  data() {
    return {
      statModalOpen: false,
    };
  },
  mounted() {
    this.statModalOpen = this.waitingStatistics;
  },
  computed: {
    cookieStatNotificationDidntSeen() {
      const cities = Cookies.getJSON('statNotification');
      return cities && cities.length ? !cities.includes(this.cityId) : true;
    },
  },
};
</script>
